import { trimInput } from "@/composables/trimInput";

const getDefaultState = () => {
  return {
    Rdc: [],
    totalElementsRdc: 0,
    currentPageRdc: 1,
    loadingRdc: true,
    errorRdc: false,
    campiLockedRdc: "",
    comandiLockedRdc: "",
    rowsToSkipRdc: 0,
    fetchRowsRdc: 25,
    sortColumnRdc: "data_inserimento",
    sortOrderRdc: "desc",
    idSocietaFilterRdc: null,
    societaDenominazioneFilterRdc: null,
    idFonteRdcFilter: null,
  };
};
const state = getDefaultState();

const getters = {
  currentPageRdc: (state) => state.currentPageRdc,
  rowsToSkipRdc: (state) => state.rowsToSkipRdc,
  fetchRowsRdc: (state) => state.fetchRowsRdc,
  sortColumnRdc: (state) => state.sortColumnRdc,
  sortOrderRdc: (state) => state.sortOrderRdc,
  societaRdcFilter: (state) => state.idSocietaFilterRdc,
  societaNameRdcFilter: (state) => state.societaDenominazioneFilterRdc,
  idFonteRdcFilter: (state) => state.idFonteRdcFilter,
};

const mutations = {
  setFetchRowsRdc: (state, value) => {
    state.currentPageRdc = 1;
    state.fetchRowsRdc = value;
  },
  setPageRdc: (state, value) => {
    state.currentPageRdc = value;
    state.rowsToSkipRdc = parseInt(
      (state.currentPageRdc - 1) * state.fetchRowsRdc
    );
  },
  setRowsToSkipRdc: (state) => {
    state.currentPageRdc = 1;
    state.rowsToSkipRdc = 0;
  },

  setSortColumnRdc: (state, value) => {
    state.currentPageRdc = 1;
    state.sortColumnRdc = value;
  },
  setSortOrderRdc: (state, value) => {
    state.currentPageRdc = 1;
    state.sortOrderRdc = value;
  },
  setIdSocietaFilterRdc: (state, value) => {
    state.idSocietaFilterRdc = value;
  },
  setSocietaDenominazioneFilterRdc: (state, value) => {
    state.societaDenominazioneFilterRdc = trimInput(value);
  },
  setIdFonteRdcFilter: (state, value) => {
    state.idFonteRdcFilter = value;
  },

  resetRdcFilters: (state) => {
    state.currentPageRdc = 1;
    state.idSocietaFilterRdc = null;
    state.societaDenominazioneFilterRdc = null;
    state.idFonteRdcFilter = null;
  },
};

export default {
  state,
  getters,
  mutations,
};
